import { createRootRouteWithContext, HeadContent, Outlet, Scripts } from "@tanstack/react-router";
import axios from "axios";
import { toast } from "react-toastify";

import { Providers } from "@/components/@custom/Providers";
import { companyServices, queueServices } from "@/domain";
import { MODAL_HANDLER } from "@/lib/Mantine";
import { RouterContext } from "@/main";
import { attendanceService } from "@/services/attendance";
import { queueService } from "@/services/queue";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  // loader: async ({ context }) => {
  //   const {
  //     store: { dispatch },
  //     state: { windowLocationHost }
  //   } = context;
  //   const company = JSON.parse(sessionStorage.getItem("@company")!) as { id: number; name: string; logo: string };
  //   const fetchSettingsV2 = await dispatch(settingsApi.endpoints.getSettingsByCompany.initiate({ id: company.id }));
  //   console.log({
  //     company,
  //     fetchSettingsV2
  //   });
  // },
  context: ({ matches }) => {
    const expeditionMatch = matches.find((match) => match.routeId === "/expedicao");

    const storageShippingCompanyId = localStorage.getItem("@App:shippingCompanyId")!;
    const companyId = localStorage.getItem("@App:companyId")!;
    const shippingCompanyIdEncrypted = String(expeditionMatch?.search.shippingCompanyIdEncrypted || "");

    const shippingCompanyId = (() => {
      if (shippingCompanyIdEncrypted && shippingCompanyIdEncrypted.length > 20) {
        const decrypted = CryptoJS.AES.decrypt(
          shippingCompanyIdEncrypted.toString().replaceAll("xMl3Jk", "+").replaceAll("Por21Ld", "/").replaceAll("Ml32", "="),
          "SecretCpf"
        ).toString(CryptoJS.enc.Utf8);
        return Number(decrypted);
      }
      if (Number(storageShippingCompanyId) && sessionStorage.getItem("@App:userRole") === "Transportadora") {
        return Number(storageShippingCompanyId);
      }
      return "";
    })() as number | string;

    const validShippingCompanyId = shippingCompanyId ? shippingCompanyId : null;
    const validCompanyId = companyId ? companyId : null;
    const getQueueFrom = validShippingCompanyId ? validShippingCompanyId : validCompanyId!;
    const getFromValue = validShippingCompanyId ? "shipping-company" : "company";

    const fetchIp = async () => {
      const { data } = await axios.get<{ ip: string }>("https://api.ipify.org/?format=json");

      return data;
    };

    const checkValidCompanyIds = () => {
      if (!validShippingCompanyId && !validCompanyId) {
        return false;
      }
      return true;
    };

    const fetchPositions = async () => {
      if (!checkValidCompanyIds()) return [];
      try {
        const positionsData = await queueServices.getQueueShippingCompanyPositions(getQueueFrom.toString());
        return positionsData;
      } catch (error) {
        toast.error("Erro ao buscar posições da fila.");
        console.error("Error fetching queue positions:", error);
        throw error;
      }
    };
    // const fetchQueues = async () => {
    //   if (!checkValidCompanyIds()) return [];
    //   try {
    //     const queuesData = await queueServices.getQueueCompany({
    //       from: getFromValue,
    //       companyId: getQueueFrom.toString()
    //     });
    //     return queuesData;
    //   } catch (error) {
    //     toast.error("Erro ao buscar filas da empresa.");
    //     console.error("Error fetching queues:", error);
    //     throw error;
    //   }
    // };
    //TODO Aqui é o fetch das filas ativas
    const fetchActiveQueues = async () => {
      if (!checkValidCompanyIds()) return [];
      try {
        const activeQueuesData = await queueServices.getQueueActiveCompany({
          from: getFromValue,
          companyId: getQueueFrom.toString()
        });
        return activeQueuesData;
      } catch (error) {
        toast.error("Erro ao buscar filas ativas da empresa.");
        console.error("Error fetching active queues:", error);
        throw error;
      }
    };
    const fetchSettings = async () => {
      try {
        const settingsData = await companyServices.getSettings(companyId);
        localStorage.setItem("@enableTolerance", JSON.stringify(settingsData.enableTolerance));
        return settingsData;
      } catch (error) {
        console.error("Error fetching settings:", error);
        throw error;
      }
    };
    const fetchDelayStatus = async () => {
      try {
        const delayResult = await queueService.query.getQueueDelayStatusByCompanyId(+companyId);
        const delayData = delayResult.data!;
        return delayData;
      } catch (error) {
        console.error("Error fetching delay status:", error);
        throw error;
      }
    };
    const fetchAttendance = async () => {
      try {
        const attendanceResult = await attendanceService.query.getTodayAttendanceByCompanyId(+companyId);
        const attendanceData = attendanceResult.data!;
        return Number(attendanceData);
      } catch (error) {
        console.error("Error fetching attendance:", error);
        throw error;
      }
    };

    let loadTimes = 0;
    async function fetchAll(options?: {
      onFirstFetch?: (firstFetch: boolean) => void;
      onInit?: () => void;
      onSuccess?: () => void;
      onError?: (error?: Error) => void;
      onFinally?: () => void;
    }) {
      const promises = [fetchSettings(), fetchDelayStatus(), fetchAttendance(), fetchPositions(), fetchActiveQueues()] as const;

      loadTimes += 1;
      function handleFirstFetch(callback: (firstFetch: boolean) => void = () => {}) {
        if (!callback) return;

        if (loadTimes > 1) {
          callback(true);
          return;
        }
        callback(false);
      }

      handleFirstFetch(options?.onFirstFetch);

      options?.onInit?.();
      try {
        const results = await Promise.allSettled(promises);
        const [settings, delayStatus, attendance, positions, /* queues, */ activeQueues] = results;
        const failures = results.filter((result) => result.status === "rejected");
        if (failures.length > 0) {
          console.warn(`${failures.length} operações falharam durante o fetch:`, failures);
        }

        const body = {
          settings: settings.status === "fulfilled" ? settings.value : null,
          delayStatus: delayStatus.status === "fulfilled" ? delayStatus.value : null,
          attendance: attendance.status === "fulfilled" ? attendance.value : null,
          positions: positions.status === "fulfilled" ? (positions.value ?? null) : null,
          // queues: queues.status === "fulfilled" ? (queues.value ?? null) : null,
          activeQueues: activeQueues.status === "fulfilled" ? (activeQueues.value ?? null) : null
        };

        options?.onSuccess?.();
        return body;
      } catch (error) {
        options?.onError?.(error as Error);
        console.error("Error fetching data:", error);
        return {
          settings: null,
          delayStatus: null,
          attendance: null,
          positions: null,
          queues: null,
          activeQueues: null
        };
      } finally {
        options?.onFinally?.();
        const isOnline = navigator.onLine;
        sessionStorage.setItem("@checkedConnect", String(isOnline));

        handleFirstFetch((isFirstFetch) => {
          if (!isFirstFetch) {
            MODAL_HANDLER.expeditions.connection.status({
              isOnline: navigator.onLine
            });
          }
        });
      }
    }

    return {
      shippingCompanyId,
      fetchs: {
        global: {
          fetchIp
        },
        expedition: {
          fetchAll,
          fetchSettings,
          fetchDelayStatus,
          fetchAttendance,
          fetchPositions,
          // fetchQueues,
          fetchActiveQueues
        }
      }
    };
  }
});

function RootComponent() {
  return (
    <Providers>
      <HeadContent />
      <Outlet />
      <Scripts />
    </Providers>
  );
}
